<template>
    <div class="d-flex justify-content-center align-items-center outside-class">
        <slot />
    </div>
</template>

<script>
export default {
    name: "GreyButton"
}
</script>

<style scoped>
.outside-class {
    background-color: #f8f8f8;
}
</style>
